// Progress bar
customElements.define(
  'progressbar-rewards',
  class ProgressBarRewards extends HTMLElement {
    constructor() {
      super();

      let selectors = {
          "progressSettings" : "[data-progressbar-rewards-settings]",
          "progressSettingsData" : "progressbarRewardsSettings",
          "progressCurrentMessage" : "[data-progressbar-rewards--current-message]",
          "progressNextMessage" : "[data-progressbar-rewards--next-message]",
          "progressCurrency" : "[data-progressbar-currency]",
          "progressImage" : "[data-progressbar-rewards--image]",
          "progressBarContainer" : "[data-progressbar-rewards--progress-bar-container]",
          "progressBar" : "[data-progressbar-rewards--progress-bar]",
          "progressThreshold" : "[data-progressbar-rewards--threshold]",
          "progressThresholdMarker" : "[data-progressbar-rewards--threshold-marker]",
      };

      this.selectors = selectors;

      this.init();

      this.processing = false;

      document.addEventListener('processingChangeRewards', (event) => {
        this.processing = event.detail.processing;
      });
    }

    getCookieItemReward(name) {
      let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    }

    setCookieItemReward(name, value, days) {
      let d = new Date;
      d.setTime(d.getTime() + 24*60*60*1000*days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    deleteCookieItemReward(name) { 
      this.setCookieItemReward(name, '', -1);
    }

    async init() {
      let progressNextMessage = this.querySelector(this.selectors.progressNextMessage);
      const progressSettingsElement = this.querySelector(this.selectors.progressSettings);

      if(progressSettingsElement !== null && progressSettingsElement !== undefined) {

        // === Get all elements

        const packSettingsData = JSON.parse(progressSettingsElement.dataset[this.selectors.progressSettingsData]);

        const progressBar = this.querySelector(this.selectors.progressBar);
        let progressThresholds = this.querySelectorAll(this.selectors.progressThreshold);

        let lastStepReach = false;

        const rewardsIsAdding = this.getCookieItemReward('rewardsIsAdding') !== '[]';
        const delay = rewardsIsAdding ? 1000 : 0;

        await new Promise(resolve => setTimeout(resolve, delay));

        const cart = await cartManager.getCart();
        let queue = Promise.resolve();

        // === Cart total price

        let cartTotalPrice = cart.total_price;

        // === Get steps info

        // - Get current and next step
        let currentStep = null;
        let nextStep = null;
        let nextThreshold = null;
        for (let index = 0; index < packSettingsData.steps.length; index++) {
          if (cartTotalPrice >= parseInt(packSettingsData.steps[index].threshold)) {
            currentStep = packSettingsData.steps[index];
            nextStep = packSettingsData.steps[index + 1];
          }
        }

        // - None step reach
        if (currentStep == null && nextStep == null) {
          nextStep = packSettingsData.steps[0];
        }

        // - Last step reach
        if (currentStep !== null && nextStep == null) {
          lastStepReach = true;
        }
        
        if (!lastStepReach) {
          const currency = this.querySelector(this.selectors.progressCurrency).getAttribute('data-progressbar-currency');
          var leftBeforeThreshold = '<span class="scz-cart-rewards__price-left">' + Shopify.formatMoney((parseInt(nextStep.threshold) - cart.total_price), 'amount_with_comma_separator') + currency + '</span>';
          var nextMessage = nextStep.before_message.replace('##left##', leftBeforeThreshold);
          nextThreshold = parseInt(nextStep.threshold);
        } else {
          var nextMessage = currentStep.after_message;
          nextThreshold = parseInt(currentStep.threshold);
        }

        progressNextMessage.innerHTML = nextMessage.replace("##%##", "'");

        if (lastStepReach) {
          progressBar.style.width = "100%";
        } else {

          // - Default: Percentage from 0€
          let percentage = (parseFloat(cartTotalPrice) * 100) / nextThreshold;

          const nextMarker = this.querySelector('[data-progressbar-rewards--threshold-marker="'+ nextThreshold.toString() +'"]');

          let currentMarker = null;
          if (currentStep !== null) {
            currentMarker = this.querySelector('[data-progressbar-rewards--threshold-marker="'+ parseInt(currentStep.threshold).toString() +'"]');
          }

          if (nextMarker !== null) {
            let nextMarkerPosition = null;
            if (currentStep !== null && currentStep.threshold != 0) {
              nextMarkerPosition = parseFloat(nextMarker.offsetLeft);
              const currentMarkerPosition = parseFloat(currentMarker.offsetLeft);

              percentage = ((parseFloat(cartTotalPrice) - parseInt(currentStep.threshold)) * 100) / (nextThreshold - parseInt(currentStep.threshold));

              progressBar.style.width = currentMarkerPosition + (percentage * ((nextMarkerPosition - currentMarkerPosition) / 100)) + "px"; 
            } else {
              nextMarkerPosition = parseFloat(nextMarker.offsetLeft);
              progressBar.style.width = percentage *  nextMarkerPosition / 100 + "px"; 
            }
          } else {
            progressBar.style.width = percentage + "%";
          }

        }

        if (progressThresholds !== null) {
          progressThresholds.forEach(function callback(threshold, index) {
            if (threshold.dataset["progressbarRewards-Threshold"] <= cartTotalPrice) {
              threshold.classList.add('active');
            } else {
              threshold.classList.remove('active');
            }
          }); 
        }

        // === Rewards products
        if (packSettingsData?.steps && packSettingsData?.steps?.length > 0 && this.processing === false) {

          let items = [];

          packSettingsData.steps.forEach( async (step) => {
            if (step.type && step.type === 'product') {

              // - Check if step threshold reach
              if (cartTotalPrice >= parseInt(step.threshold)) {
                // - Check if product already added
                let productAlreadyAdded = false;
                for (let index = 0; index < cart.items.length; index++) {
                  if (cart.items[index].properties !== null) {
                    if (cart.items[index].properties['_is_reward'] === true ) {
                      if (step.id == cart.items[index].properties["_reward_id"]) {
                        productAlreadyAdded = true;
                      }
                    }
                  }
                }

                // - Check reward is adding
                let rewardsIsAdding = [];
                let productAlreadyIsAdding = false;
                if (this.getCookieItemReward('rewardsIsAdding') !== null) {
                  rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
                }

                if (rewardsIsAdding.length > 0) {
                  rewardsIsAdding.forEach(rewardIsAdding => {
                    if (rewardIsAdding.id === step.id) {
                      productAlreadyIsAdding = true;
                    }
                  });
                }

                // - Check reward is banned
                let rewardsBanned = [];
                let productIsBanned = false;
                if (this.getCookieItemReward('rewardsBanned') !== null) {
                  rewardsBanned = JSON.parse(this.getCookieItemReward('rewardsBanned'));
                }       
                
                if (rewardsBanned.length > 0) {
                  rewardsBanned.forEach(rewardBanned => {
                    if (rewardBanned.id === step.id) {
                      productIsBanned = true;
                    }
                  });
                }
                

                // - If product not added: add product
                
                if (productAlreadyAdded === false && productAlreadyIsAdding === false && productIsBanned === false) {

                  // - Add cookie is adding
                  rewardsIsAdding.push({
                    variant_id: step.variant_id,
                    threshold: step.threshold,
                    id: step.id
                  });
                  this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

                  // - Set items to add
                  if (step.type === 'product') {

                    items.push(
                      {
                        id: step.variant_id,
                        quantity: 1,
                        properties: {
                          '_is_reward': true,
                          '_reward_id': step.id,
                          '_reward_threshold': step.threshold
                        }
                      }
                    );

                  }
                  
                }
                
              }
              
            }
          });

          // === setcookieNull

          // === Add items
          if (items.length > 0) {

            queue = queue.then(async () => {
              const rewardAddedResult = await this.addItems(items);
              if (rewardAddedResult === true) {

                // - Get cookie 'rewardsAdded'
                let rewardsAdded = [];
                if (this.getCookieItemReward('rewardsAdded') !== null) {
                  rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
                }

                // - Get cookie 'rewardsIsAdding'
                let rewardsIsAdding = [];
                if (this.getCookieItemReward('rewardsIsAdding') !== null) {
                  rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
                }

                items.forEach(item => {

                  // - Add reward in cookie 'rewardsAdded'
                  let itemIsAlreadyInCookie = false;
                  if (rewardsAdded.length > 0) {
                    rewardsAdded.forEach(rewardAdded => {
                      if (rewardAdded.id === item.properties['_reward_id']) {
                        itemIsAlreadyInCookie = true;
                      }
                    });
                  }
                  if (itemIsAlreadyInCookie === false) {
                    rewardsAdded.push({
                      variant_id: item.id,
                      threshold: item.properties['_reward_threshold'],
                      id: item.properties['_reward_id']
                    });
                  }

                  // - Remove reward in cookie 'rewardsIsAdding'
                  if (rewardsIsAdding.length > 0) {
                    for (let index = 0; index < rewardsIsAdding.length; index++) {
                      if(rewardsIsAdding[index].id == item.properties['_reward_id']) {
                        rewardsIsAdding.splice(index, 1);
                      }
                    }
                  }
                  
                });

                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
                this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

              }

            });
            
          }

        }

        // === Remove items: If reward product added and his threshold > cartTotalPrice: remove this reward product
        if (cart.items && cart.items.length > 0) {

          let itemsToRemove = {};

          for (let index = 0; index < cart.items.length; index++) {
            if (cart.items[index].properties !== null) {
              if (cart.items[index].properties['_is_reward'] === true) {
                if (parseInt(cart.items[index].properties['_reward_threshold']) > cartTotalPrice) {

                  // - Check reward is removing
                  let rewardsIsRemoving = [];
                  let productAlreadyIsRemoving = false;
                  if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
                    rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
                  }
                  if (rewardsIsRemoving.length > 0) {
                    rewardsIsRemoving.forEach(rewardIsRemoving => {
                      if (rewardIsRemoving.id === cart.items[index].properties["_reward_id"]) {
                        productAlreadyIsRemoving = true;
                      }
                    });
                  }

                  if (productAlreadyIsRemoving === false) {

                    // - Add cookie is removing
                    rewardsIsRemoving.push({
                      variant_id: cart.items[index].variant_id,
                      threshold: cart.items[index].properties["_reward_threshold"],
                      id: cart.items[index].properties["_reward_id"]
                    });
                    this.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

                    // - Set items to remove
                    itemsToRemove[cart.items[index].variant_id] = 0;

                  }

                }
              }
            }
          }

          // Remove items
          if (Object.keys(itemsToRemove).length > 0) {
            queue = queue.then(async () => {

              const rewardsRemoved = await this.removeItems(itemsToRemove);
              if (rewardsRemoved === true) {

                // - Get cookie 'rewardsAdded'
                let rewardsAdded = [];
                if (this.getCookieItemReward('rewardsAdded') !== null) {
                  rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded'));
                }

                // - Get cookie 'rewardsIsRemoving'
                let rewardsIsRemoving = [];
                if (this.getCookieItemReward('rewardsIsRemoving') !== null) {
                  rewardsIsRemoving = JSON.parse(this.getCookieItemReward('rewardsIsRemoving'));
                }

                for (const [key] of Object.entries(itemsToRemove)) {
                  
                  // - Remove reward in cookie 'rewardsAdded'
                  if (rewardsAdded.length > 0) {
                    for (let index = 0; index < rewardsAdded.length; index++) {
                      if(rewardsAdded[index].variant_id == key.toString()) {
                        rewardsAdded.splice(index, 1);
                      }
                    }
                  }

                  // - Remove reward in cookie 'rewardsIsRemoving'
                  if (rewardsIsRemoving.length > 0) {
                    for (let index = 0; index < rewardsIsRemoving.length; index++) {
                      if(rewardsIsRemoving[index].variant_id == key.toString()) {
                        rewardsIsRemoving.splice(index, 1);
                      }
                    }
                  }

                }

                this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
                this.setCookieItemReward('rewardsIsRemoving', JSON.stringify(rewardsIsRemoving), 3);

              }

            });
          }
        }

        // === Queue error
        queue.catch((e) => {
          console.error(e);
        });
        

        // === [Security] If cartTotalPrice == 0: delete cookie 'rewardsAdded'
        if (cartTotalPrice == 0) {
          this.deleteCookieItemReward('rewardsAdded');
          this.deleteCookieItemReward('rewardsIsAdding');
          this.deleteCookieItemReward('rewardsIsRemoving');
          this.deleteCookieItemReward('rewardsBanned');
        }
      }
    }

    reverseNodeList(nodeList) {
      const array = Array.from(nodeList);    
      const reversedArray = array.reverse();
      return reversedArray;
    }

    async addItems(items) {
      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      const itemsData = {
        'items': items
      };
      config.body = JSON.stringify(itemsData);
    
      try {
        const response = await fetch('/cart/add.js?drawer-item-reward', config);
        const result = await response.json();
    
        if (response.ok) {
          return true; // Requête réussie
        } else {
          console.error("Erreur lors de l'ajout d'articles au panier:", result);
          const allLoadingOverlay = this.querySelectorAll('.loading-overlay');
          if (allLoadingOverlay.length > 0) {
            allLoadingOverlay.forEach((overlay) =>
              overlay.classList.add('hidden'),
            );
          }
          return false; // Requête échouée
        }
      } catch (e) {
        console.error("Erreur lors de l'ajout d'articles au panier:", e);
        return false; // Gestion des erreurs
      }
    }
    

    async removeItems(items) {
      const config = fetchConfig('javascript');
      config.headers['Content-Type'];
      config.body = JSON.stringify({
        updates: items
      });
    
      try {
        const response = await fetch('/cart/update.js?drawer-item-reward', config);
        const result = await response.json();
    
        if (response.ok) {
          return true; // Requête réussie
        } else {
          console.error("Erreur lors de la suppression d'articles du panier:", result);
          return false; // Requête échouée
        }
      } catch (e) {
        console.error("Erreur lors de la suppression d'articles du panier:", e);
        return false; // Gestion des erreurs
      }
    }
    
  }
);

customElements.define(
  'drawer-item-reward',
  class DrawerItemReward extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        "updateRewardTrigger" : "[data-item-reward-update]",
        "updateRewardKey" : "itemRewardUpdateKey",
        "updateRewardPanel" : "[data-item-reward-panel]",
        "updateRewardPanelClose" : "[data-item-reward-panel-close]",
        "updateRewardPanelItem" : "[data-item-reward-panel-item]",
        "updateRewardPanelItemId" : "itemRewardPanelItemVariant",
        "updateRewardPanelChange" : "[data-item-reward-panel-change]",
        "updateRewardPanelBanned" : "[data-item-reward-panel-banned]",
        "updateRewardPanelBannedStepId" : "itemRewardPanelBannedStepId",
      };

      this.updateRewardTrigger = this.querySelector(this.selectors.updateRewardTrigger);
      this.updateRewardKey = this.updateRewardTrigger.dataset[this.selectors.updateRewardKey];
      this.updateRewardPanel = this.querySelector(this.selectors.updateRewardPanel);
      this.updateRewardPanelClose = this.querySelector(this.selectors.updateRewardPanelClose);
      this.updateRewardPanelItems = this.querySelectorAll(this.selectors.updateRewardPanelItem);
      this.updateRewardPanelChange = this.querySelector(this.selectors.updateRewardPanelChange);
      this.updateRewardPanelBanned = this.querySelector(this.selectors.updateRewardPanelBanned);

      this.isProcessing = false; // Variable d'état pour éviter le spam
      this.selectedItem = null;  // Stocke l'élément actuellement sélectionné

      this.init();
    }

    async init() {
      this.setupEventListeners();
    }

    setupEventListeners() {
      let self = this;

      this.updateRewardTrigger.addEventListener('click', () => this.open());
      this.updateRewardPanelClose.addEventListener('click', () => this.close());

      this.updateRewardPanelItems.forEach((updateRewardPanelItem) => {
        updateRewardPanelItem.addEventListener('click', (event) => {
          self.selectItem(updateRewardPanelItem);
        });
      });

      
      this.updateRewardPanelChange.addEventListener('click', async () => {
        if (self.isProcessing) return;

        // Si aucun item n'a été sélectionné (l'utilisateur veut garder le produit actuel), fermer le panneau
        if (!self.selectedItem) {
          self.close();
          return;
        }

        self.isProcessing = true;
        self.updateRewardPanelChange.setAttribute('disabled', '');
        self.updateRewardPanelChange.classList.add('loading');
        self.updateRewardPanelChange.querySelector('.loading-overlay').classList.remove('hidden');

        try {
          await self.processRewards();
        } catch (error) {
          console.error("Error processing rewards:", error);
        } finally {
          self.isProcessing = false;
          self.updateRewardPanelChange.removeAttribute('disabled');
        }
      });

      this.updateRewardPanelBanned.addEventListener('click', async () => {
        if (self.isProcessing) return;
        self.isProcessing = true;
        self.updateRewardPanelBanned.setAttribute('disabled', '');

        let setp_id = self.updateRewardPanelBanned.dataset[self.selectors.updateRewardPanelBannedStepId];

        if (!setp_id) {
          return;
        }

        try {
          await self.bannedReward(setp_id);
        } catch (error) {
          console.error("Error processing rewards:", error);
        } finally {
          self.isProcessing = false;
          self.updateRewardPanelChange.removeAttribute('disabled');
        }
      });
    }

    selectItem(updateRewardPanelItem) {
      if (this.isProcessing) return;

      this.updateRewardPanelItems.forEach((updateRewardPanelItem) => {
        updateRewardPanelItem.classList.remove('active');
      });
      updateRewardPanelItem.classList.add('active');

      this.selectedItem = updateRewardPanelItem;
    }

    async processRewards() {
      const cart = await cartManager.getCart();
      const variantId = this.selectedItem.dataset[this.selectors.updateRewardPanelItemId];
      let properties = {};
    
      const cartItem = cart.items.find(i => i.key === this.updateRewardKey);
      if (cartItem) {
        properties = cartItem.properties;
      }
    
      if (variantId === "null") {
        let rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsIsAdding') || "[]");
        rewardsAdded.push({
          variant_id: variantId,
          threshold: properties['_reward_threshold'],
          id: properties['_reward_id']
        });
        this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsAdded), 3);
      }
    
      document.dispatchEvent(new CustomEvent('processingChangeRewards', { bubbles: true, detail: { processing: true } }));
    
      // Toujours encapsuler les appels en try...catch pour gérer les erreurs
      try {
        await this.updateItemById(this.updateRewardKey, 0);
        const itemAdded = await this.addItem(variantId, 1, properties); // Assurez-vous que cela attend l'addItem
        if (itemAdded) {
          // Ajoutez des logiques de succès supplémentaires ici, si nécessaire
        }
      } catch (error) {
        console.error("Error processing rewards:", error);
      } finally {
        this.isProcessing = false; // Réinitialisez le statut de traitement
        document.dispatchEvent(new CustomEvent('processingChangeRewards', { bubbles: true, detail: { processing: false } }));
      }
    }

    async bannedReward(setp_id) {
      const cart = await cartManager.getCart();
      const itemWithGift1 = cart.items.find(item => item.properties && item.properties._reward_id === setp_id);

      if (!itemWithGift1) {
        return;
      }
    
      document.dispatchEvent(new CustomEvent('processingChangeRewards', { bubbles: true, detail: { processing: true } }));
    
      try {
        try {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: itemWithGift1.key,
              quantity: 0
            })
          });
        } catch (error) {
          console.error("Error updating item:", error);
        }

        let rewardsBanned = JSON.parse(this.getCookieItemReward('rewardsBanned') || "[]");
        rewardsBanned.push({
          variant_id: itemWithGift1.id,
          id: setp_id
        });
        this.setCookieItemReward('rewardsBanned', JSON.stringify(rewardsBanned), 3);
        this.close();
      } catch (error) {
        console.error("Error processing rewards:", error);
      }
    }
    
    

    open() {
      this.updateRewardPanel.classList.add('active');
    }

    close() {
      this.updateRewardPanel.classList.add('close');
      this.updateRewardPanel.classList.remove('active');
      setTimeout(() => this.updateRewardPanel.classList.remove('close'), 1000);
    }

    setCookieItemReward(name, value, days) {
      let d = new Date();
      d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * days));
      document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()}`;
    }

    getCookieItemReward(name) {
      const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
      return match ? match[2] : null;
    }

    async addItem(variantId, quantity, properties) {
      if (Object.keys(properties).length === 0) {
        return;
      }
    
      try {

        await fetch("/cart/add.js?drawer-item-reward", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            properties: properties
          })
        });

    
        // Mise à jour du cookie rewardsAdded
        let rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded') || "[]");
    
        // Trouver l'index de l'élément à mettre à jour dans rewardsAdded
        const rewardIndex = rewardsAdded.findIndex(reward => reward.id === properties['_reward_id']);
        if (rewardIndex !== -1) {
          rewardsAdded[rewardIndex].variant_id = variantId; // Remplacez le variant_id
        } else {
          // Si le reward n'existe pas, vous pouvez l'ajouter ou décider quoi faire
          rewardsAdded.push({
            variant_id: variantId,
            threshold: properties['_reward_threshold'],
            id: properties['_reward_id']
          });
        }
    
        this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);


        let rewardsIsAdding = [];
        if (this.getCookieItemReward('rewardsIsAdding') !== null) {
          rewardsIsAdding = JSON.parse(this.getCookieItemReward('rewardsIsAdding'));
        }

        if (rewardsIsAdding.length > 0) {
          for (let index = 0; index < rewardsIsAdding.length; index++) {
            if(rewardsIsAdding[index].id == properties['_reward_id']) {
              rewardsIsAdding.splice(index, 1);
            }
          }
        }

        this.setCookieItemReward('rewardsIsAdding', JSON.stringify(rewardsIsAdding), 3);

        document.dispatchEvent(new CustomEvent('processingChangeRewards', { bubbles: true, detail: { processing: false } }));
    
      } catch (error) {
        console.error("Error adding item:", error);
      }
    }
    
    

    async updateItem(data) {
      try {
        await fetch("/cart/change.js?drawer-item-reward", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        });
      } catch (error) {
        console.error("Error updating item:", error);
      }
    }

    updateItemById(lineItemId, newQuantity) {
      return this.updateItem({
        id: lineItemId,
        quantity: newQuantity
      }).then(() => {
        if (newQuantity > 0) {
            // Mise à jour du cookie rewardsAdded
            let rewardsAdded = JSON.parse(this.getCookieItemReward('rewardsAdded') || "[]");
        
            for (let index = 0; index < rewardsAdded.length; index++) {
              if(lineItemId.includes(rewardsAdded[index].variant_id)) {
                rewardsAdded.splice(index, 1);
              }
            }
        
            this.setCookieItemReward('rewardsAdded', JSON.stringify(rewardsAdded), 3);
        }
      }).catch(error => {
        console.error("Error updating item:", error);
      });
    }
    
    
  }
);